import { isExpired, decodeToken } from "react-jwt";

export const setToken = (name, token) => {
  window.localStorage.setItem(name, JSON.stringify(token));
};

export const getToken = (name) => {
  const tokenJson = window.localStorage.getItem(name);
  try {
    const token = JSON.parse(tokenJson);
    return typeof token === "string" && token.length > 0 ? token : null;
  } catch {
    return null;
  }
};

export const getTokenRefresh = () => {
  return getToken("ctknre");
};

export const getClientToken = () => {
  return getToken("cdttkn");
};

export const deleteToken = (nameToken) => {
  window.localStorage.removeItem(nameToken);
};

export const verifyExpireTokenRefresh = () => {
  const token = getTokenRefresh();

  if (!token) return true;

  const isTokenExpired = isExpired(token);
  return isTokenExpired;
};

export const decodeTokenRefresh = (token) => {
  return decodeToken(token)?.uid ?? null;
};

export const decodeClientToken = (token) => {
  const { name, lastname, email, phone } = decodeToken(token) ?? {};
  return { name, lastname, email, phone };
};
